import { isEmpty } from 'lodash';
import {
  ALL_AUTHOR_GROUP_TARGETS,
  generateNextMemberKey,
  getAuthorGroupMembersMetaData,
  resetAuthorsTotalCounts
} from './AuthorGroupsUtils';

/**
 * `state.selectedAuthorGroup` is an object of the following fields with example values:
 * {
 *     id: 'database string id',
 *     name: 'Group 1',
 *     members: {}
 * }
 *
 * Each field of `members` is an object with the following fields - `memberKey` is an number:
 *
 * <memberKey>: {
 *   value: string,
 *   label: string,
 *   type: string,
 *   authors: string[]
 * }
 *
 * e.g.
 *
 * '4': {
 *   value: 'twitter_author',
 *   label: 'Twitter Author',
 *   type: 'author',
 *   authors: [ 'Author1', 'Author2', ...]
 * }
 */

export const AUTHOR_GROUPS_INIT_STATE = {
  authorGroupTitle: '', // empty string prevents showing the author group panel
  selectedAuthorGroup: {
    id: '',
    name: '',
    members: {}
  },
  memberKeyList: ['0'],
  authorsTotalCounts: resetAuthorsTotalCounts(),

  /*
   * An authorGroup member value is excluded and not available for the
   * other members if it is selected in a member's dropdown AND has authors.
   */
  unusedAuthorGroupTargets: ALL_AUTHOR_GROUP_TARGETS
};

export const authorGroupsReducer = (state, action) => {
  switch (action.type) {
    case 'reset': // only the AuthorGroupsList will be shown, no NEW or EDIT GROUP panel
      return {...AUTHOR_GROUPS_INIT_STATE};
    case 'new-author-group':
      return {
        ...AUTHOR_GROUPS_INIT_STATE,
        authorGroupTitle: 'NEW GROUP'
      };
    case 'add-blank-author-group-member':
      const newMemberKey = isEmpty(state.memberKeyList) ? '0' : generateNextMemberKey(state.memberKeyList);
      return {
        ...state,
        selectedAuthorGroup: {
          ...state.selectedAuthorGroup,
          members: {
            ...state.selectedAuthorGroup.members,
            [newMemberKey]: {}
          }
        },
        memberKeyList: [...state.memberKeyList, newMemberKey]
      };
    case 'set-author-group-name':
      return {
        ...state,
        selectedAuthorGroup: {
          ...state.selectedAuthorGroup,
          name: action.name
        }
      };
    case 'set-selected-author-group':
      const { totalCounts, unUsedTargets } = getAuthorGroupMembersMetaData(action.authorGroup);
      return {
        ...state,
        authorGroupTitle: action.title ? action.title : state.authorGroupTitle,
        selectedAuthorGroup: { ...action.authorGroup },
        memberKeyList: Object.keys(action.authorGroup.members),
        authorsTotalCounts: totalCounts,
        unusedAuthorGroupTargets: unUsedTargets
      };
    default:
      throw new Error(`Unknown reducer action: ${JSON.stringify(action)}`);
  }
};

